/*
 * Copyright (c) 2019. Nedaware SL
 */

import {FilterInterface, InvalidFilterValue} from "../../api/filter-interface";
import {InternalPropertyMap} from "../basic-entity-interface/mapping-internal";
import {Uri} from "../../api/uri";

/**
 * Nedaware S.L.
 * @author David Campos Rodríguez <david.campos.r96@gmail.com>
 */

/**
 * Obtains the parameters to make a search by an array of IRIs.
 */
export class IriSearchFilter implements FilterInterface {
    dataToParams(property: InternalPropertyMap | null, data: any[] | any): { [p: string]: string | string[] } {
        if (!Array.isArray(data)) {
            throw new InvalidFilterValue(data, "values for iri-search must be arrays");
        }

        data = data.map(each => {
            if (typeof each === "string") {
                return each;
            } else if (each instanceof Uri) {
                return each.toString();
            } else {
                throw new InvalidFilterValue(each, "the value is not a string nor an iri");
            }
        });

        return {"iri-search[]": data};
    }
}
